/** Label/value row used by review steps (Create event, Discount codes). */
export function SummaryRow({ label, value }) {
  if (!value) return null;
  return (
    <div className="flex gap-3 py-2 border-b last:border-0 text-sm">
      <span className="text-muted-foreground w-44 flex-shrink-0">{label}</span>
      <span className="font-medium break-all">{String(value)}</span>
    </div>
  );
}

/** Bordered review section with an icon and a title. */
export function SummarySection({ icon: Icon, title, children }) {
  return (
    <div className="rounded-xl border p-4 space-y-1">
      <div className="flex items-center gap-2 mb-3">
        <Icon className="h-4 w-4 text-primary" />
        <p className="text-sm font-semibold">{title}</p>
      </div>
      {children}
    </div>
  );
}
